import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { PAMachine } from "./types";

export const paMachineListService = (params: {
  keyword?: string | null;
  code?: string | null;
  name?: string | null;
  page?: number | null;
  limit?: number | null;
  groupMachineId?: string | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAMachine>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paMachineListShortService = (params: {
  keyword?: string | null;
  code?: string | null;
  name?: string | null;
  page?: number | null;
  limit?: number | null;
  groupMachineId?: string | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAMachine>>({
    method: HTTPRequestMethods.GET,
    url: Paths.Short,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paMachineCreateService = (params: {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  groupMachineId: string;
}) =>
  RestAPIClient.call<PAMachine>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paMachineUpdateService = ({
  id,
  ...rest
}: Parameters<typeof paMachineCreateService>[0] & {
  id: string;
  status?: number;
}) =>
  RestAPIClient.call<PAMachine>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${String(id)}`,
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const paMachineDetailService = (id: string) =>
  RestAPIClient.call<PAMachine>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const paMachineDeleteService = (id: string) =>
  RestAPIClient.call<PAMachine>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
